@let hasDescription = isDefined(description);
<div class="flex flex-col min-h-20 md:min-h-fit">
  @if (hasDescription) {
    <div class="text-body-large">{{ description }}</div>
  }
  @if (isDefined(title)) {
    <div class="text-wrap" mxTruncate [mxTruncateMaxLines]="2" [class.text-label-large]="hasDescription" [class.text-title-medium]="!hasDescription">
      {{ title }}
    </div>
  }
  @if (isDefined(transactionId)) {
    <div class="text-body-medium">TRN ID: {{ transactionId }}</div>
  }
  @if (isDefined(date)) {
    <div class="text-body-medium">Date: {{ date | format: 'DATE_ONLY' }}</div>
  }
  @if (isDefined(amount)) {
    <div class="text-body-medium">Amount: {{ amount | format: 'POSITIVE_CURRENCY' }}</div>
  }
</div>
